// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".language-selection .v-btn-toggle .v-btn[data-v-29155392]{color:#8e8e8e;font-weight:600;margin:0;text-transform:uppercase}.language-selection .v-btn-toggle .v-btn--active[data-v-29155392]{color:#fff}.language-selection .v-btn-toggle .v-btn[data-v-29155392]:before{background:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
